import { useEffect, useState } from "react";
import { fetchAtlas } from "../../api";

const defaultAtlases = { data: null, loading: false, error: null, totalCount: 0 };
export const usePagedAtlases = (atlasId, start, limit, tags) => {
    const [atlases, setAtlases] = useState(defaultAtlases);
    const tagsStr = tags.join(",");
    const [, setAbortController] = useState();
    useEffect(() => {
        const callback = async () => {
            setAtlases(prevState => ({
                ...prevState,
                loading: true,
                error: null,
            }));
            window.scrollTo({
                left: 0,
                top: 0,
            });
            const _abortController = new AbortController();
            setAbortController(abortController => {
                if (abortController) {
                    abortController.abort();
                }
                return _abortController;
            });
            const data = await fetchAtlas(atlasId, start, limit, tagsStr, _abortController.signal);
            if (data) {
                setAtlases({
                    data: {
                        ...data,
                        items: data.items.map((item, index) => ({
                            ...item,
                            order: start + index + 1,
                        })),
                    },
                    totalCount: data.totalResults,
                    loading: false,
                });
            } else {
                setAtlases(prevAtlases => ({
                    data: {
                        ...prevAtlases.data,
                        items: [],
                    },
                    totalCount: 0,
                    loading: false,
                }));
            }
        };
        callback();
    }, [atlasId, start, limit, tagsStr]);
    return atlases;
};
